<div class="rich-text-editor border border-stroke-muted overflow-visible">
  <div #editorContainer></div>
</div>
